<template>
  <date-picker
    :value="value"
    :open.sync="open"
    type="time"
    format="HH:mm"
    value-type="format"
    placeholder="Selecione a hora"
    :lang="ptBr"
    :disabled="disabled"
    :clearable="false"
    @change="onChange"
  ></date-picker>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ptBr from "vue2-datepicker/locale/pt-br";
import "vue2-datepicker/index.css";

export default {
  name: "ScheduledTimeField24h",
  components: { DatePicker },
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Hora",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ptBr,
      open: false,
    };
  },
  methods: {
    onChange(time, type) {
      if (type === "minute") {
        this.open = false;
      }
      this.$emit("input", time || "");
    },
  },
};
</script>